import * as React from 'react';
import { chooseIconIndex } from 'utils/helperMethods';
const iconIndex = chooseIconIndex();

const SvgComponent = () => {
    //2K
    if (iconIndex === 1) {
        return (
            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.66663 1.66663L6.99996 6.99996L12.3333 1.66663"
                    stroke="#44338A"
                    stroke-width="2.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //4K
    if (iconIndex === 2) {
        return (
            <svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M2 2L10 10L18 2"
                    stroke="#44338A"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
        );
    }
    //BELOW 2K
    return (
        <svg width={10} height={7} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m1 1.5 4 4 4-4" stroke="#44338A" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default SvgComponent;
